// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-21a_K","header":"header-2AUXN","popup__header":"popup__header-3w79U"};